export const downloadFromUrl = (url: string, fileName: string) => {
    const link = document.createElement('a');

    link.href = url;
    link.download = fileName;
    link.rel = 'noopener';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
